var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _class, _temp2;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

import React, { Component } from 'react';

import Media from './Media';
import MediaHeader from './MediaHeader';
import MediaFooter from './MediaFooter';
import MediaFigure from './MediaFigure';
import MediaContent from './MediaContent';

import { NavSettings, NavTabs, NavAction } from "../";

import ImageEditFocalpoint from './ImageEditFocalpoint';
import ImageEditCropdata from './ImageEditCropdata';

var templates = {
    "focalpoint": ImageEditFocalpoint,
    "cropdata": ImageEditCropdata
};

var MediaEditable = (_temp2 = _class = function (_Component) {
    _inherits(MediaEditable, _Component);

    function MediaEditable() {
        var _temp, _this, _ret;

        _classCallCheck(this, MediaEditable);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.state = {
            template: undefined
        }, _this.onEditProperty = function (name, value) {
            var formData = _this.props.formData;


            if (_this.props.onChange) {
                var _extends2;

                _this.props.onChange(_extends({}, formData, (_extends2 = {}, _extends2[name] = value, _extends2)));
            }
        }, _this.onEditFocalpoint = function (focalpoint) {
            _this.onEditProperty("focalpoint", focalpoint);
        }, _this.onEditCropdata = function (cropdata) {
            _this.onEditProperty("cropdata", cropdata);
        }, _this.getMenu = function () {
            var menu = _this.props.menu;


            if (!menu) {
                return false;
            }

            var mediaMenu = menu.map(function (item) {

                if (item.name === "content") {
                    return _extends({}, item, {
                        icon: "notes"
                    });
                }

                if (item.name === "focalpoint") {
                    return _extends({}, item, {
                        icon: "center_focus_strong"
                    });
                }

                if (item.name === "cropdata") {
                    return _extends({}, item, {
                        icon: "crop"
                    });
                }

                return _extends({}, item);
            });

            return mediaMenu;
        }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    MediaEditable.prototype.render = function render() {
        var _props = this.props,
            editable = _props.editable,
            editing = _props.editing,
            collapsible = _props.collapsible,
            expanded = _props.expanded,
            expandName = _props.expandName,
            mediaId = _props.mediaId,
            media = _props.media,
            formData = _props.formData,
            settings = _props.settings,
            onSave = _props.onSave;


        var menu = this.getMenu();
        var label = this.props.title || false;

        if (!mediaId) {

            return React.createElement(
                Media,
                _extends({}, this.props, { expanded: false }),
                React.createElement(MediaFooter, this.props)
            );
        }

        if (editable && editing) {

            var template = void 0;

            if (expandName) {
                template = expandName;
            } else if (menu && menu.length) {
                template = menu[0].name;
            }

            if (templates[template]) {
                var MediaEditTemplate = templates[template];

                return React.createElement(
                    Media,
                    _extends({}, this.props, { expanded: true }),
                    React.createElement(
                        MediaHeader,
                        null,
                        React.createElement(NavTabs, { tabs: menu }),
                        React.createElement(NavAction, { buttonType: 'secondary', button: { title: "Lagre", onClick: onSave }, align: 'right' })
                    ),
                    React.createElement(MediaEditTemplate, _extends({}, formData, { media: media, onFocalpoint: this.onEditFocalpoint, onCrop: this.onEditCropdata }))
                );
            }

            return React.createElement(
                Media,
                _extends({}, this.props, { format: 'auto', expanded: true }),
                React.createElement(
                    MediaHeader,
                    null,
                    React.createElement(NavTabs, { tabs: menu }),
                    React.createElement(NavAction, { buttonType: 'secondary', button: { title: "Lagre", onClick: onSave }, align: 'right' })
                ),
                React.createElement(
                    MediaContent,
                    null,
                    this.props.children
                )
            );
        }

        return React.createElement(
            Media,
            _extends({}, this.props, { expanded: false }),
            React.createElement(MediaFigure, this.props),
            React.createElement(NavSettings, _extends({}, this.props, { settings: settings }))
        );
    };

    return MediaEditable;
}(Component), _class.defaultProps = {
    id: undefined,
    expanded: false,
    menu: false,
    formData: {}
}, _temp2);


export default MediaEditable;